import { render, staticRenderFns } from "./Stratage.vue?vue&type=template&id=f1ae5824&scoped=true&"
import script from "./Stratage.vue?vue&type=script&lang=js&"
export * from "./Stratage.vue?vue&type=script&lang=js&"
import style1 from "./Stratage.vue?vue&type=style&index=1&id=f1ae5824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ae5824",
  null
  
)

export default component.exports